<script setup>
    import { ref, computed, onMounted, onBeforeUnmount } from 'vue'
    import {useToast} from 'vue-toast-notification'
    import 'vue-toast-notification/dist/theme-sugar.css'
    import axios from 'axios'
    import Loading from '@/components/Loading.vue'
    import EstablishmentItem from '@/components/EstablishmentItem.vue'
    import { useLocalStorage } from '@/composables/useLocalStorage.js'
  
    const emit = defineEmits(['push'])

    const toast = useToast()

    const currentLocation = ref(null)
    const listEstablishments = ref([])
    const isEmpty = ref(false)

    const logo = useLocalStorage('__logo', 'img/app-icons/android-chrome-192x192.png')
    
    const ShowEstablishment = (item) => {
      logo.value = item.logo 
      setTimeout(_ => emit('push', item.id), 0)
    }

    function requestGeolocation() {
      fetchEstablishments()
      /*
      if (navigator.geolocation) {
        isEmpty.value = false
        navigator.geolocation.getCurrentPosition(
          (position) => {
            const { latitude, longitude } = position.coords
            currentLocation.value = { latitude, longitude }
            fetchEstablishments()
          },
          (error) => {
            let error_message = ''
            switch (error.code) {
              case error.PERMISSION_DENIED:
                error_message = 'Permiso denegado para acceder a la ubicación.'
                break
              case error.POSITION_UNAVAILABLE:
                error_message = 'Información de ubicación no disponible.'
                break
              case error.TIMEOUT:
                error_message = 'Tiempo de espera agotado al intentar obtener la ubicación.'
                break
              default:
                error_message = 'Error al obtener la ubicación: ' + error.message
            }

            toast.open({
              message: error_message,
              type: 'default',
              position: 'bottom'
            })
          }
        );
      } else {
        toast.open({
          message: 'La geolocalización no está soportada en este navegador.',
          type: 'default',
          position: 'bottom'
        })
      }
      */
    }

    async function fetchEstablishments() {
        currentLocation.value = {latitude:19.4326, longitude:-99.1332}
        if (currentLocation.value) {
            const items = await GetEstablishments(currentLocation.value)
            if (items.isRight()) {
              listEstablishments.value = items.get()
              isEmpty.value = listEstablishments.value.length === 0
            }
        }
    }

    function GetEstablishments(location) {
        return axios.get('branches/nearby', {
          params: {
            lat: location.latitude,
            lng: location.longitude,
            radius: 1250
          },
          headers: {
            'Content-Type': 'application/json'
          }
        })
        .then(response => ({
            isRight: () => true,
            get: () => response.data || []
        }))
        .catch(error => {
            console.error('Error:', error)
            return {
              isRight: () => false,
              get: () => []
            }
        })
    }

    /*function handleVisibilityChange() {
      if (document.visibilityState === 'visible') {
        requestGeolocation()
      }
    }*/

    onMounted(() => {
      logo.value = "img/app-icons/android-chrome-192x192.png"
      requestGeolocation()
      //document.addEventListener('visibilitychange', handleVisibilityChange)
    })

    onBeforeUnmount(() => {
      //document.removeEventListener('visibilitychange', handleVisibilityChange)
    })
</script>

<template>
    
    <div v-if="listEstablishments.length > 0">
      <div class="px-2 mb-4">
          <small class="text-lg block pt-2 text-gray-800/25 dark:text-white/25 pb-0 font-bold">Hola!</small>
          <label class="text-4xl pb-2 block font-bold">¿Dónde estás?</label>
          <label class="text-2xl block mb-8 font-thin">Decide & Descubre</label>
        </div>
        <h3 class="mx-3 mt-6">Establecimientos</h3>
        <EstablishmentItem
          v-for="(item, index) in listEstablishments" 
          :key="index" 
          @click="ShowEstablishment(item)"
          :item="item"
        />
    </div>
    <Loading
      v-else
      :isEmpty="isEmpty"
      title="Lo sentimos"
      description="No hemos encontrado ningún establecimiento cercano a ti."
    />
</template>
